import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PagedTableWrapperComponent } from './paged-table-wrapper.component';

@NgModule({
   declarations: [PagedTableWrapperComponent],
   imports: [CommonModule, MatIconModule],
   exports: [PagedTableWrapperComponent],
})
export class PagedTableWrapperModule {}
